module.exports = __webpack_public_path__ + "img/src/modules/web-agent/assets/img/maven-dropdown-arrow.png?e7d66b981d1251a8d9e0d5a28a08ba94";